<template>
    <div class="autocomplete">
        <input 
            type="text"
            class="input-autocomplete"
            :class="{'input-danger': isError}"
            v-model="query.value"
            v-on:keyup="handleInput($event)"
            @focus="handleFocus"
            @blur="handleBlur"
        />
        <ul class="li-options" ref="optionsList" v-show="visible">
            <li 
                v-for="(item , index) in filterItems"
                :key="index"
                @mousedown="handleSelect(item)"
            >
                <slot name="custom-items" :data="item">{{item}}</slot>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'AutoCompleteProduct',
    props: {
        data: String,
        items: Array,
        index: Number,
        field: String,
        isError: Boolean
    },
    data() {
        return {
        query: {
          value: this.data,
        },
        filterItems: this.items,
        visible:false,
      }
    },
    watch: { 
      data(newVal) {
        return this.query.value = newVal
      }
    },
    methods:{
      handleInput(event){
        this.$emit('input' , this.index, this.field, event.target.value)
        this.searchData()
      },
      clearData(){
        this.visible = false
      },
      handleSelect(val) {
        this.$emit('select:item', this.index, this.field, val)
      },
      handleFocus() {
        this.visible = true
      },
      handleBlur(){
        this.visible = false
      },
      searchData(){
        if (this.query.value.length > 0) {
            const regex = new RegExp(this.query.value, 'i')
            const filter = this.filterItems.filter((v) => regex.test(v))
            this.filterItems = filter
        } else {
            this.filterItems = this.items
        }

      }
    }
}
</script>

<style scoped>
.autocomplete{
    width: 100%;
    position: relative;

}
.input-autocomplete {
    width: 100%;
    border-radius: 5px;
}
.input-danger {
    border-color: #fb6340;
}
.li-options {
    position: absolute;
    background-color: white;
    width: 100%;
    z-index: 99999;
    list-style-type: none;
    box-shadow: 0 0 1px #00000087;
    top: 40px;
    padding-left: 0;
    overflow-y: overlay;
    max-height: 180px;
    cursor: pointer;
}
.li-options li {
    padding-left: 8px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #c5c5c5;
}
.li-options li:hover {
    background-color: #f1f1f1;
}
</style>